import { render, staticRenderFns } from "./_purchasse.vue?vue&type=template&id=d68a7f0e&"
import script from "./_purchasse.vue?vue&type=script&lang=js&"
export * from "./_purchasse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports